// src/pages/ItemStock/ItemStockSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchItemStockReport } from "./ItemStockThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    warehouseId: null,
    itemId: null,
    categoryId: null,
    groupId: null,
  },
};

const itemStockSlice = createSlice({
  name: "itemStock",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemStockReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemStockReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchItemStockReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = itemStockSlice.actions;
export default itemStockSlice.reducer;
